export default __webpack_public_path__ + "static/media/KHARINA.3bf500a9.png";